import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { SquareButton } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    '&:hover > div, &:focus > div, &:active > div': {
      opacity: 100,
    },
    [theme.media.tablet]: {
      opacity: 100,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  buttons: {
    position: 'absolute',
    right: -theme.marginBase * 7,
    top: 0,
    opacity: 0,
    '&:hover, &:focus, &:active': {
      opacity: 100,
    },
    [theme.media.tablet]: {
      opacity: 100,
      position: 'static',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      margin: theme.marginBase * 2,
      order: -1,
    },
  },
  hiddenOnMobile: {
    [theme.media.mobile]: {
      display: 'none',
    },
  },
}));

interface Props {
  children: React.ReactNode;
  onDeleteClick?: () => any;
  containerClassName?: string;
  buttonsClassName?: string;
  topButtons?: React.ReactNode;
  isHiddenOnMobile?: boolean;
}

export const DeletableItem = forwardRef(
  (props: Props, ref: React.Ref<HTMLDivElement> | undefined) => {
    const theme: Theme = useTheme();
    const classes = useStyles({ theme });

    return (
      <div
        className={classnames(classes.container, props.containerClassName)}
        ref={ref}
      >
        {props.children}
        <div
          className={classnames(classes.buttons, props.buttonsClassName, {
            [classes.hiddenOnMobile]: props.isHiddenOnMobile,
          })}
        >
          {props.topButtons}
          {props.onDeleteClick && (
            <SquareButton
              icon="ri-delete-bin-line"
              color="red"
              onClick={props.onDeleteClick}
              title="Delete"
            />
          )}
        </div>
      </div>
    );
  },
);
